const primary = {
  // primary dark-mode
  white:
    'bg-core-white hover:bg-core-gray-200 focus-visible:ring-core-oxide-bright active:bg-core-gray-400 text-core-gray-950',
  // primary light-mode
  black:
    'bg-core-gray-950 hover:bg-core-gray-800 focus-visible:ring-core-oxide active:bg-core-gray-950 text-core-white',
  // brand light-mode
  oxide:
    'bg-core-oxide hover:brightness-110 focus-visible:ring-core-oxide active:brightness-90 text-core-white',
  // brand dark-mode
  'oxide-bright':
    'bg-core-oxide-bright hover:brightness-110 focus-visible:ring-core-oxide-bright active:brightness-90 text-core-gray-950',
  // neutral dark-mode
  gray: 'bg-core-gray-900 backdrop-blur-xl hover:brightness-110 focus-visible:ring-core-oxide-bright active:brightness-90 text-core-white',
  // neutral light-mode
  lightGray:
    'bg-core-gray-300 hover:brightness-110 focus-visible:ring-core-oxide active:brightness-90 text-core-black',
}

// deprecated - prefer neutral
const secondary = {
  white:
    'border border-core-white text-core-white hover:bg-core-gray-800 focus-visible:ring-core-white active:bg-core-gray-800 active:text-core-gray-400',
  black:
    'border border-core-gray-950 text-core-gray-950 hover:bg-core-gray-100 focus-visible:ring-core-gray-950 active:bg-core-gray-300 active:text-core-gray-700',
  oxide:
    'border border-core-oxide text-core-oxide hover:bg-core-oxide-600 hover:text-core-white focus-visible:ring-core-oxide-600 active:text-core-gray-300 active:bg-core-oxide-600',
  gray: 'border border-core-gray-600 text-core-gray-600 hover:bg-core-gray-100 focus-visible:ring-core-gray-600 active:bg-core-gray-100 active:text-core-gray-800',
}

const transparent = {
  // light-mode
  black:
    'text-core-black backdrop-blur-xl border border-transparent bg-core-black/10 hover:brightness-105 focus-visible:ring-core-oxide active:brightness-95',
  // dark-mode
  white:
    'text-core-white backdrop-blur-xl border border-transparent bg-core-white/20 hover:brightness-110 focus-visible:ring-core-oxide-bright active:brightness-95',
}

const text = {
  white:
    'text-core-white border border-transparent hover:bg-core-white/5 focus-visible:ring-core-oxide-bright active:bg-core-white/10',
  black:
    'text-core-black border border-transparent hover:bg-core-black/5 focus-visible:ring-core-oxide active:bg-core-black/10',
}

// i.e. text only
const link = {
  white: 'text-core-white active:text-core-oxide-bright',
  black: 'text-core-black active:text-core-oxide',
  // deprecated
  oxide: 'text-core-oxide active:text-core-oxide-600',
}

const config = {
  primary,
  secondary,
  transparent,
  text,
  link,
}

export default config
